import {Injectable} from '@angular/core';
import {LocalUser, LocalUserState} from '@app/state/local-user.state';
import {Store} from '@ngxs/store';
import {AccessType} from '@app/modules/shared/data/constants';
import {UtilService} from '@app/modules/shared/services/util.service';

@Injectable({
  providedIn: 'root'
})
export class SmartsuppService {
  private localUser: LocalUser;

  constructor(private store: Store) {
    this.listenStoreChanges();
  }

  private listenStoreChanges(): void {
    this.store.select(LocalUserState).subscribe((localUser: LocalUser) => {
      this.localUser = localUser;
    });
  }

  public buildUsername(includeRolePrefix: boolean): string {
    const name = UtilService.generateFullName(this.localUser);
    if (includeRolePrefix) {
      if (this.localUser.isGuest) {
        return 'GUEST: ' + name;
      } else if (this.localUser.accessType !== AccessType.STUDENT) {
        return this.localUser.accessType.toString() + ': ' + name;
      } else {
        return name;
      }
    } else {
      return name;
    }
  }
}
